export const isObjectEmpty = (
  obj: Record<string, unknown> | undefined,
): boolean => {
  if (!obj) {
    return true;
  }

  return Object.keys(obj).length === 0;
};
